/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Use_TodayInputs */

const en_us2_swap_use_today = /** @type {(inputs: Swap_Use_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use today`)
};

const pt_br2_swap_use_today = /** @type {(inputs: Swap_Use_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar hoje`)
};

const es_419_swap_use_today = /** @type {(inputs: Swap_Use_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar hoy`)
};

const pt_pt2_swap_use_today = /** @type {(inputs: Swap_Use_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar hoje`)
};

const fr_fr2_swap_use_today = /** @type {(inputs: Swap_Use_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prendre aujourd'hui`)
};

const de_de2_swap_use_today = /** @type {(inputs: Swap_Use_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute nehmen`)
};

const it_it2_swap_use_today = /** @type {(inputs: Swap_Use_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa oggi`)
};

/**
* | output |
* | --- |
* | "Use today" |
*
* @param {Swap_Use_TodayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_use_today = /** @type {((inputs?: Swap_Use_TodayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Use_TodayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_use_today(inputs)
	if (locale === "es-419") return es_419_swap_use_today(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_use_today(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_use_today(inputs)
	if (locale === "de-DE") return de_de2_swap_use_today(inputs)
	if (locale === "it-IT") return it_it2_swap_use_today(inputs)
	return en_us2_swap_use_today(inputs)
});
export { swap_use_today as "swap.use_today" }